<template>
  <PflegeBaseSectionTemplate
    v-editable="props.blok"
    :data-uid="props.blok._uid"
    :anchor="anchor"
    :text-align="stringOrUndefined(props.blok.alignment)"
  >
    <template v-if="props.blok.media?.length" #media>
      <Media
        v-for="asset in props.blok.media"
        :key="asset._uid"
        :blok="asset"
        :aspect-ratio="{
          desktop: aspectRatios.xs,
          tablet: aspectRatios.s,
          mobile: aspectRatios.s
        }"
      />
    </template>

    <template v-if="props.blok.intro?.length" #intro>
      <IntroComponent :blok="props.blok.intro[0]" />
    </template>

    <template v-if="props.blok.content?.length" #content>
      <div class="list-wrapper">
        <WPStepList :blok="props.blok.content[0]" />
        <template v-if="props.blok.actions?.length">
          <Button v-for="button in props.blok.actions" :key="button._uid" :blok="button" />
        </template>
      </div>
    </template>

    <template v-if="props.blok.secondDivider?.length" #secondDivider>
      <Divider :blok="props.blok.secondDivider[0]" />
    </template>

    <template v-if="props.blok.closing?.length" #closing>
      <ClosingComponent :blok="props.blok.closing[0]" />
    </template>

    <template v-if="props.blok.thirdDivider?.length" #thirdDivider>
      <Divider :blok="props.blok.thirdDivider[0]" />
    </template>
  </PflegeBaseSectionTemplate>
</template>

<script setup lang="ts">
import aspectRatios from '../constants/aspectRatios'
import { type DividerBlok, type WPStepListBlok, type WPElementMediaBlok, type IntroComponentBlok, type ButtonBlok, type ClosingComponentBlok, stringOrUndefined, type BlokWithEmpty, WPElementMedia, WPElementButton } from '@webcarelbj/shared-bloks'
import { findComponent, PflegeBaseSectionTemplate, type TextAlignment } from '@webcarelbj/shared-components'

const Media = findComponent(WPElementMedia)
const Button = findComponent(WPElementButton)

const props = defineProps<{
  blok: {
    media?: WPElementMediaBlok[]
    intro?: IntroComponentBlok[]
    content?: WPStepListBlok[]
    actions?: ButtonBlok[]
    alignment?: BlokWithEmpty<TextAlignment>
    closing?: ClosingComponentBlok[]
    secondDivider?: DividerBlok[]
    thirdDivider?: DividerBlok[]
    component: 'StepSection'
    _uid: string
  }
}>()
const anchor = computed(() => {
  return props.blok.intro?.length && props.blok.intro?.[0].anchor
    ? props.blok.intro[0].anchor
    : ''
})
</script>

<style scoped lang="scss">
.list-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
